import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { documentTypes } from "@/js/lists.ts";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
import InboundDeliveryRelatedFilesTable from "@/components/inbound/InboundDeliveryRelatedFilesTable.vue";
export default {
  name: "AdminInboundDeliveryAttachedFilesDrawer",
  components: {
    UploaderV2: UploaderV2,
    confirm: confirmationComponent,
    AddTagToDocumentDialog: AddTagToDocumentDialog,
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    InboundDeliveryRelatedFilesTable: InboundDeliveryRelatedFilesTable
  },
  props: {
    id: Number,
    items: [],
    loggedUserData: Object
  },
  data: function data() {
    return {
      drawer: false,
      isMakingDrawerStateless: false,
      attachedFiles: [],
      wineDocuments: [],
      wineryDocuments: [],
      documentTags: [],
      loadings: {
        isLoadingAttachedFiles: false,
        isLoadingWineFiles: false,
        isLoadingWineryFiles: false
      },
      documentTypes: documentTypes,
      filters: {
        search: null,
        selectedTags: []
      },
      fetchAttachedFilesToken: null,
      fetchWineDocumentsToken: null,
      fetchWineryDocumentsToken: null,
      removeFileToken: null
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/inbound/").concat(this.id, "/files");
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchAttachedFiles();
          case 2:
            _this2.fetchWineDocuments();
            _this2.fetchWineryDocuments();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openDrawer: function openDrawer() {
      this.drawer = true;
      this.fetchWineDocuments();
      this.fetchWineryDocuments();
    },
    closeDrawer: function closeDrawer() {
      this.drawer = false;
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    fetchDocumentTags: function fetchDocumentTags(documentTags) {
      this.documentTags = documentTags;
    },
    updateFilters: function updateFilters(filters) {
      this.filters = filters;
    },
    fetchAttachedFiles: function fetchAttachedFiles() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchAttachedF;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.loadings.isLoadingAttachedFiles = true;
              (_this3$fetchAttachedF = _this3.fetchAttachedFilesToken) === null || _this3$fetchAttachedF === void 0 || _this3$fetchAttachedF.cancel();
              _this3.fetchAttachedFilesToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/inbound/delivery/".concat(_this3.id, "/files"), "get", null, true, "api", null, _this3.fetchAttachedFilesToken).then(function (response) {
                _this.attachedFiles = _toConsumableArray(response.data.value);
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.isLoadingAttachedFiles = false;
                  throw e;
                }
              });
            case 6:
              _this3.loadings.isLoadingAttachedFiles = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWineDocuments: function fetchWineDocuments() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$fetchWineDocum;
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loadings.isLoadingWineFiles = true;
              (_this4$fetchWineDocum = _this4.fetchWineDocumentsToken) === null || _this4$fetchWineDocum === void 0 || _this4$fetchWineDocum.cancel();
              _this4.fetchWineDocumentsToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 6;
              return request("/v1/inbound/delivery/".concat(_this4.id, "/files/wines"), "post", {
                items: _this4.items,
                searchLabel: _this4.filters.search,
                documentTags: _this4.filters.selectedTags
              }, true, "api", null, _this4.fetchWineDocumentsToken).then(function (response) {
                _this4.wineDocuments = _toConsumableArray(response.data.value);
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineFiles = false;
                  throw e;
                }
              });
            case 6:
              _this4.loadings.isLoadingWineFiles = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchWineryDocuments: function fetchWineryDocuments() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$fetchWineryDoc;
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.loadings.isLoadingWineryFiles = true;
              (_this5$fetchWineryDoc = _this5.fetchWineryDocumentsToken) === null || _this5$fetchWineryDoc === void 0 || _this5$fetchWineryDoc.cancel();
              _this5.fetchWineryDocumentsToken = axios.CancelToken.source();
              _this = _this5;
              _context4.next = 6;
              return request("/v1/inbound/delivery/".concat(_this5.id, "/files/wineries"), "post", {
                items: _this5.items,
                searchLabel: _this5.filters.search,
                documentTags: _this5.filters.selectedTags
              }, true, "api", null, _this5.fetchWineryDocumentsToken).then(function (response) {
                _this.wineryDocuments = _toConsumableArray(response.data.value);
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineryFiles = false;
                  throw e;
                }
              });
            case 6:
              _this5.loadings.isLoadingWineryFiles = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    upload: function upload() {
      this.fetchAttachedFiles();
    },
    removeFile: function removeFile(fileId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirmed, _this6$removeFileToke, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.isMakingDrawerStateless = true;
              _context5.next = 3;
              return _this6.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context5.sent;
              if (!confirmed) {
                _context5.next = 12;
                break;
              }
              _this6.loadings.isLoadingAttachedFiles = true;
              (_this6$removeFileToke = _this6.removeFileToken) === null || _this6$removeFileToke === void 0 || _this6$removeFileToke.cancel();
              _this6.removeFileToken = axios.CancelToken.source();
              _this = _this6;
              _context5.next = 11;
              return request("/v1/inbound/delivery/".concat(_this6.id, "/files/").concat(fileId), "delete", null, true, "api", null, _this6.removeFileToken).catch(function (e) {
                _this.$toasted.show("Unable to remove this file.", {
                  type: "error"
                });
                _this.loadings.loadings.isLoadingAttachedFiles = false;
                throw e;
              });
            case 11:
              _this6.fetchAttachedFiles();
            case 12:
              _this6.isMakingDrawerStateless = false;
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.INBOUND_DELIVERY);
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this7;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(confirm) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!confirm) {
                          _context6.next = 3;
                          break;
                        }
                        _context6.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.INBOUND_DELIVERY.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (response) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchAttachedFiles();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    }
  }
};